import { experiences } from '../data';

export default function Experience() {
  return (
    <section id="experience" className="section">
      <div className="container">
        <div className="section__divider"><span>Experience</span></div>

        <div className="exp-list">
          {experiences.map((exp, i) => (
            <article key={i} className="exp-entry">
              <h3 className="exp-entry__company">{exp.company}</h3>
              <p className="exp-entry__meta">
                <span className="exp-entry__role">{exp.role}</span>
                <span className="exp-entry__dot">·</span>
                <span>{exp.date}</span>
                {exp.badge && (
                  <>
                    <span className="exp-entry__dot">·</span>
                    <span>{exp.badge}</span>
                  </>
                )}
              </p>

              {exp.intro && <p className="exp-entry__intro">{exp.intro}</p>}
              {exp.points && (
                <ul className="exp-points">
                  {exp.points.map((p, j) => (
                    <li key={j}>{p}</li>
                  ))}
                </ul>
              )}
              {exp.outro && <p className="exp-entry__outro">{exp.outro}</p>}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
